import { getComponentName } from '../../../helpers/componentHelpers';
import { GridCustomColumnClass } from './GridCustomColumnClass';

export const componentName = getComponentName('grid-custom-column');

customElements.define(componentName, GridCustomColumnClass);
